'use client';
import React, { useState } from 'react';
import SoloMealItemList from '../solo-meal-item-list';
import SolomealCategory from './solomeal-category';
import { useAiFoodOrderStore } from '@/store/use-ai-store';

export default function SolomealContainer() {
  const address = useAiFoodOrderStore.use.address();
  const lat = address?.lat ?? 10.762622;
  const lng = address?.lng ?? 106.660172;
  const [selectedCategory, setSelectedCategory] = useState<
    string | undefined
  >();

  return (
    <div className="min-h-screen bg-neutral-5" data-testid="solomeal-screen">
      <SolomealCategory
        selectedCategory={selectedCategory}
        onCategoryChange={setSelectedCategory}
      />

      <SoloMealItemList lat={lat} lng={lng} category={selectedCategory} />
    </div>
  );
}
